<script>
import { Doughnut } from 'vue-chartjs'
import API from '@/api/log'
import moment from 'moment'

export default {
  extends: Doughnut,
  data() {
    return {
      accessCountsByGender: { }
    }
  },
  mounted() {
    this.options = {
      legend: {
        position: "bottom"
      },
      tooltips: {
        enabled: true
      },
      plugins: {
        datalabels: {
          display: true,
          color: '#FFF',
          font: function(context) {
            return {
              size: 12
            }
          }
        }
      }
    };
    this.$emit('counts-updated', !this.checkEmpty());
    this.updateChartData();
  },
  computed: {
    chartData() {
      return {
        labels: this.makeLabels,
        datasets: [{
          data: this.countsByGender,
          backgroundColor: this.makeBackground,
          borderWidth: 0,
          hoverBackgroundColor: this.makeHoverBackground
        }]
      }
    },
    countsByGender() {
      if (this.checkEmpty()) {
        return [1];
      }
      const res = ['male', 'female', 'other'].map(g => this.accessCountsByGender[g]||0);
      return res;
    },
    makeLabels() {
      return (this.checkEmpty()) ? [this.$t('Analysis.User.none')] : [this.$t('Analysis.User.male'),this.$t('Analysis.User.female'),this.$t('Analysis.User.other')]
    },
    makeBackground() {
      return (this.checkEmpty()) ? ['#EEE'] : ['#009CE1','#99D7F3','#BDEDFF']
    },
    makeHoverBackground() {
      return (this.checkEmpty()) ? ['#EEE'] : []
    }
  },
  methods: {
    checkEmpty: function()
    {
      return Object.keys(this.accessCountsByGender).length === 0;
    },
    render : function()
    {
      let d = this.chartData.datasets
      let o = this.options
      let colors = ['#009CE1','#99D7F3','#BDEDFF']

      d.hoverBackgroundColor = colors
      d.backgroundColor = colors
      d.borderWidth = 1
      o.plugins.datalabels.display = true
      o.tooltips.enabled = true

      if (this.checkEmpty()){
        d.hoverBackgroundColor = ['#EEE']
        d.backgroundColor = ['#EEE']
        d.borderWidth = 0
        o.plugins.datalabels.display = false
        o.tooltips.enabled = false
      }
      this.renderChart(this.chartData, this.options)
    },
    updateChartData: function() {
      const that = this;
      const reqParams = {
        date: moment().format('YYYY-MM-DD')
      };
      API.getAccessCountsByGender(reqParams).then(function(response) {
        if (response && response.access_counts_by_gender) {
          that.accessCountsByGender = response.access_counts_by_gender;
        } else {
          that.accessCountsByGender = { };
        }
      });
    },
  },
  watch: {
    accessCountsByGender() {
      this.$emit('counts-updated', !this.checkEmpty());
      this.render()
    }
  }
}
</script>

